module.exports = __webpack_public_path__ + "img/bitcoin-icon.48b475b8.svg";